module.exports = __webpack_public_path__ + "img/20s.e7442db1.png";